// -- other --
import {useState,useEffect} from "react";
import ImageWithBasePath from "../../core/img";
import {Link} from "react-router-dom";
import {all_routes} from "../router/all_routes";
// -- biz9  --
import {UrlQuery} from "biz9-react-utility";
import {Log,Response_Logic} from "biz9-utility";
import {Image_Format} from "biz9-image";
import SubValue from "../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";
import {Data_Logic} from "biz9-data-app";
import {Config,Message} from "../../constant";
import {App,Field_Logic,Image,Toast_Message,Storage} from "../../project";
const Faq = () => {
    /* -- DEFINE -- *
     * --- PAGE-EDIT-FIELDS ---
     *  1 - group - tbd
     *
     */
    const query = UrlQuery();
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    const [faqs,setFaqs]= useState([]);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_page_data();
            },[]);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_items_data();
            },[]);
    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.FAQ_HOME.title_url,option);
        bind_page(data);
    };
    async function get_items_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_home_items(App.get_url(Portal_Page.FAQ_HOME[Portal_Type.ITEMS_URL]),option);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function bind_page(data) {
        // page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
    async function bind_items(data) {
        // -- faqs --
        setFaqs(data[Portal_Type.FAQS]);
    };
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        value: sub_value.value
                        }
                        }));
        }else{
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        items: sub_value.items
                        }
                        }));
        }
    }
    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item">
            <Link to={all_routes.home}>Home</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
            {sub_value_group.sub_value_1.value}
            </li>
            </ol>
            </nav>
            <h2 className="breadcrumb-title">
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
            {sub_value_group.sub_value_1.value}
            </h2>
                </div>
                </div>
                </div>
                </div>
                {/* /Breadcrumb */}
            {/* Faq Sction */}
            <section className="faq-section">
                <div className="container">
                <div className="section-title mb-4 aos" data-aos="fade-up">
                <h2 className="mb-1">
                {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,2):""}
            {sub_value_group.sub_value_2.value}
            </h2>
                <p>
                {" "}
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,3):""}
            {sub_value_group.sub_value_3.value}
            </p>
                </div>
                <div className="row">
                <div className="col-md-12">
                <div className="faq-wrapper faq-lists">
                {faqs.map((item) => (
                            <div className="faq-card aos" data-aos="fade-up">
                            <h4 className="faq-title">
                            <Link className="collapsed" data-bs-toggle="collapse" to={"#"+item.id} aria-expanded="false" >
                            {item.question}
                            </Link>
                            </h4>
                            <div id={item.id} className="card-collapse collapse">
                            <div className="faq-content">
                            <p>
                            {item.answer}
                            </p>
                            </div>
                            </div>
                            </div>
                            ))}
            </div>
                </div>
                </div>
                </div>
                <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
                </section>
                {/* /Faq Sction */}
            </>
                );
};

export default Faq;
